import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { MILLISECONDS } from '../../../common/utils/date';
import { formatTime } from './format';
export default class Countdown extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "timeout", void 0);
    this.state = {
      current: this.getCurrent()
    };
  }
  componentDidMount() {
    this.update();
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  update() {
    const {
      step
    } = this.props;
    const current = this.getCurrent();
    this.setState({
      current
    });
    if (current > 0) {
      this.timeout = setTimeout(() => this.update(), step);
    }
  }
  getCurrent() {
    const {
      until
    } = this.props;
    return until - Date.now();
  }
  render() {
    const {
      isFocusable,
      titlePrefix,
      className
    } = this.props;
    const {
      current
    } = this.state;
    const time = formatTime(current);
    return /*#__PURE__*/React.createElement("span", {
      className: className,
      role: "timer",
      "aria-label": titlePrefix + " " + time,
      tabIndex: isFocusable ? 0 : -1,
      dir: "auto"
    }, time);
  }
}
_defineProperty(Countdown, "defaultProps", {
  step: MILLISECONDS.ONE_SECOND,
  titlePrefix: ''
});
//# sourceMappingURL=countdown.js.map